import { render } from "./SkeletonHero.vue?vue&type=template&id=159cebac&scoped=true"
import script from "./SkeletonHero.vue?vue&type=script&lang=js"
export * from "./SkeletonHero.vue?vue&type=script&lang=js"

import "./SkeletonHero.vue?vue&type=style&index=0&id=159cebac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159cebac"]])

export default __exports__